import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { ownerNav } from '@/lib/navConfig';
import TransactionsHistory from '@/components/transactions/TransactionsHistory';

export default function OwnerTransactions() {
  return (
    <AppShell nav={ownerNav} title="Riwayat Transaksi" showBell>
      <TransactionsHistory />
    </AppShell>
  );
}
